import React, { FunctionComponent } from 'react';
import AppStoreBadge from './app-store.svg';
import GooglePlayBadge from './google-play.svg';

export enum StoreType {
    IOS,
    ANDROID,
}

export type StoreBadgeProps = {
    type: StoreType.IOS | StoreType.ANDROID;
    url: string;
    a11yText?: string;
};

const StoreBadge: FunctionComponent<StoreBadgeProps> = ({ type, url, a11yText }) => {
    return (
        <a className="store-badge" href={url} aria-label={a11yText}>
            {type === StoreType.IOS ? <AppStoreBadge /> : <GooglePlayBadge />}
        </a>
    );
};

export default StoreBadge;
